import { useEffect, useMemo, useState } from "react";
import { Offense } from "../types";
import { readCSV } from "../utils";

const CODES_CSV = "codes.csv"

export function useInitialData() {
  // CSV data
  const [codesData, setCodesData] = useState<any[]>([]);

  // Lists derived from CSV data
  const [offenses, setOffenses] = useState<Offense[]>([]);

  useEffect(() => {
    readCSV(CODES_CSV, setCodesData);
  }, []);

  useEffect(() => {
    const offenses = codesData.map((item) => ({
      code: item["MO Offense Code"],
      description: `${item["MO Offense Code"]}: ${item["Incident Name"]}`,
    }));
    setOffenses(offenses);
  }, [codesData]);

  return useMemo(
    () => ({
      codesData,
      offenses,
    }),
    [codesData, offenses]
  );
}
